import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { DateTime } from 'luxon';

import { AppSelectors } from 'store/App';
import { useAppSelector } from 'store/hooks';
import { useFormatDateTime } from 'util/helpers';
import { Text } from 'components';

export const LastUpdatedIndicator = () => {
  const { t } = useTranslation();

  const updatedAt = useAppSelector(AppSelectors.selectUpdatedAt);
  const isSidebarMinimized = useAppSelector(
    AppSelectors.selectIsSidebarMinimized,
  );

  const formatDateTime = useFormatDateTime();

  return (
    <View style={styles.container}>
      <Text color="white" align="center">
        {t(
          !isSidebarMinimized
            ? 'sideBar.infoSection.updatedAt'
            : 'sideBar.infoSection.updatedAt_short',
          {
            dateTime: updatedAt
              ? formatDateTime(updatedAt, DateTime.TIME_SIMPLE)
              : 'N/A',
          },
        )}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    textAlign: 'center',
    alignItems: 'center',
  },
});
